import { CSSProperties } from 'react'
import { BookingCarDiscount } from '~/shared/api'
import { CURRENCY } from '~/shared/config/constants'
import { formatDays, calculateDiscountPrice } from '~/shared/lib/utils'
import { DiscountChipText, DiscountChipWrapper, OldPrice } from './styled'

type DiscountChipProps = {
  discount: BookingCarDiscount
  pricePerDay: number
  style?: CSSProperties
}

export function DiscountChip({
  discount,
  pricePerDay,
  style,
}: DiscountChipProps) {
  if (!discount) {
    return null
  }
  const discountPrice = calculateDiscountPrice(pricePerDay, discount)

  return (
    <DiscountChipWrapper style={style}>
      <DiscountChipText>
        {discountPrice.toLocaleString()} {CURRENCY}
        <OldPrice>
          {pricePerDay.toLocaleString()} {CURRENCY}
        </OldPrice>
        на {formatDays(discount.details.duration_days)}
      </DiscountChipText>
    </DiscountChipWrapper>
  )
}
